module.exports = __webpack_public_path__ + "img/icon2.0960164f.svg";